module.exports = __webpack_public_path__ + "img/Group 70@3x.2b06f83d.png";